import React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';
import { DeleteBasketitem } from '../Redux/ActionCreator';
import Rating from '@material-ui/lab/Rating';
import Button from '@material-ui/core/Button';

import { connect } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: 10,
  },
  paper: {
    padding: theme.spacing(2),
    margin: '0 auto',
  },
  image: {
    width: '70%',
    height: 128,
  },
  img: {
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
  },
}));

const mapDispatchToProps = (dispatch) => ({
  DeleteBasketitem: (index) => dispatch(DeleteBasketitem(index)),
});

const mapStateToProps = (state) => {
  return {
    Basket: state.Basket,
  };
};
function BasketItem(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <Grid container spacing={2}>
          <Grid item>
            <ButtonBase className={classes.image}>
              <img
                className={classes.img}
                alt="complex"
                src={props.item.image}
              />
            </ButtonBase>
            <Typography gutterBottom variant="subtitle1">
              <Rating
                name="hover-feedback"
                value={props.item.rating}
                precision={0.5}
                // onChange={(event, newValue) => {
                //   setValue(newValue);
                // }}
                // onChangeActive={(event, newHover) => {
                //   setHover(newHover);
                // }}
              />
            </Typography>
          </Grid>
          <Grid item xs={12} sm container>
            <Grid item xs container direction="column" spacing={2}>
              <Grid item xs>
                <Typography gutterBottom variant="subtitle1">
                  <strong>{props.item.title}</strong>
                </Typography>
                <Typography variant="body2" gutterBottom>
                  {props.item.discription}
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body2" style={{ cursor: 'pointer' }}>
                  <Button
                    size="small"
                    color="primary"
                    onClick={() => {
                      props.DeleteBasketitem(props.index);
                    }}
                  >
                    Remove from basket
                  </Button>
                </Typography>
              </Grid>
            </Grid>
            <Grid item>
              <Typography variant="subtitle1">$2000.00</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(BasketItem);
